import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import { getLandingPagePath } from '@/lib/landing-page';
import { HOME_FALLBACK_PATHS } from '@/lib/route-access';

/**
 * Wrapper do index route `/`. Lê `landingPage` do level do user logado e
 * redireciona pra rota correspondente (ex: `/dashboard/management/support`).
 *
 * Quando o user ou level está sem landingPage, cai no `DEFAULT_LANDING_PAGE`
 * (resolvido em `getLandingPagePath`).
 *
 * Se a pessoa não pode abrir a tela inicial (a padrão é o painel de
 * Atendimento, que muita gente não tem — 108 usuários em produção em
 * 20/10/2026), vai para a primeira tela que pode abrir, na ordem do menu.
 * Sem isso, a trava de rotas mostraria "acesso negado" logo depois do login.
 */
export const HomeRedirect: React.FC = () => {
  const { state } = useAuth();
  const { canAccessPath } = usePermissions();
  const landingPage = state.user?.level?.landingPage;
  const preferred = getLandingPagePath(landingPage);
  const path = canAccessPath(preferred)
    ? preferred
    : HOME_FALLBACK_PATHS.find((p) => canAccessPath(p)) ?? '/settings/account';
  return <Navigate to={path} replace />;
};

HomeRedirect.displayName = 'HomeRedirect';
